import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import bdeReducer from './bdeSlice';
import ordersReducer from './ordersSlice';
import shopsReducer from './shopsSlice';
import payoutsReducer from './payoutsSlice';
import productsReducer from './productsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    bde: bdeReducer,
    orders: ordersReducer,
    shops: shopsReducer,
    payouts: payoutsReducer,
    products: productsReducer,
  },
});
